export const spacing = {
	margin: "1.3rem",
	padding: "1.25rem",
	borderRadius: "1.5rem",
};
